import { Mapper } from "../../../../base/utils/mapper";
import { ViaEnterModel } from "../../../../domain/models/consult/via-enter.model";
import { ViaEnterEntity } from "../entities/via-enter-response.entity";


export class ViaEnterImplementationRepositoryMapper extends Mapper<ViaEnterEntity, ViaEnterModel> {
    mapFrom(param: ViaEnterEntity): ViaEnterModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ViaEnterModel): ViaEnterEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}